import React from 'react';
import { Modal, Button } from '@canaveral/components';
import PropTypes from 'prop-types';
import cx from 'classnames';
import displayOpts from '../displayOpts';
import style from './styles.scss';

const propTypes = {
  hideOnMobile: PropTypes.bool,
  displayOpt: PropTypes.string,
  onFinishEdit: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
};

const defaultProps = {
  hideOnMobile: undefined,
  displayOpt: undefined,
};

class Editor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hideOnMobile: false,
      whiteOr: false,
      displayOpt: displayOpts.find(opt => opt.default).value,
    };
  }

  componentDidMount = () => {
    const { hideOnMobile, displayOpt, whiteOr } = this.props;
    const newState = {};
    if (hideOnMobile !== undefined) {
      newState.hideOnMobile = hideOnMobile;
    }
    if (displayOpt) {
      newState.displayOpt = displayOpt;
    }
    if (whiteOr !== undefined) {
      newState.whiteOr = whiteOr;
    }
    this.setState({ ...newState });
  }

  toggleHideOnMobile = e => this.setState({ hideOnMobile: e.target.checked });

  toggleWhiteOr = e => this.setState({ whiteOr: e.target.checked });

  selectDisplay = e => this.setState({ displayOpt: e.target.value });

  handleSave = () => {
    const { displayOpt, hideOnMobile, whiteOr } = this.state;
    const { onFinishEdit } = this.props;

    onFinishEdit({ displayOpt, hideOnMobile, whiteOr });
  }

  render = () => {
    const { onCancelEdit } = this.props;
    const { hideOnMobile, displayOpt, whiteOr } = this.state;

    const { component } = displayOpts.find(opt => opt.value === displayOpt);
    const previewComponent = React.cloneElement(component, { isPreview: true, whiteOr });

    return (
      <Modal
        show
        onDismiss={onCancelEdit}
        size="xl"
        aria-labelledby="Search and Geo Location Editor"
      >
        <Modal.Header>
          <Modal.Title id="Search and Geo Location Editor">
            Search and Geolocation Editor
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={style.settingsPane}>
            <div>
              <div className={style.settingsHeader}>
                Select which search options your users will have when visiting your site.
              </div>
              {displayOpts.map(({ value, label }) => (
                <div key={value}>
                  <input
                    type="radio"
                    value={value}
                    checked={displayOpt === value}
                    onChange={this.selectDisplay}
                    id={value}
                  />
                  <label htmlFor={value} className={style.label}>
                    {label}
                  </label>
                </div>
              ))}
            </div>
            <div>
              <div className={style.settingsHeader}>
                Mobile Settings
              </div>
              <input type="checkbox" checked={hideOnMobile} onChange={this.toggleHideOnMobile} id="hideOnMobile" />
              <label htmlFor="hideOnMobile" className={style.label}>
                Hide this widget on mobile devices
              </label>
            </div>
            {displayOpt === 'both' ? (
               <div>
                <div className={style.settingsHeader}>
                  Display Settings
                </div>
                <input type="checkbox" checked={whiteOr} onChange={this.toggleWhiteOr} id="whiteOr" />
                <label htmlFor="whiteOr" className={style.label}>
                  Use white or
                </label>
               </div>
            ) : null}
          </div>
          <div className={style.previewPane}>
            <div className={cx({
              [style.previewContainer]: true,
              [style.darkPreviewContainer]: whiteOr && displayOpt === 'both',
              theme: true,
            })}
            >
              {previewComponent}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button context="neutral" onClick={onCancelEdit}>
            Cancel
          </Button>
          <Button context="success" onClick={this.handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

Editor.propTypes = propTypes;
Editor.defaultProps = defaultProps;

export default Editor;
